import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'
import './styles.css'
import { updateComponent } from '../../state/actions/componentsActions'

class PrivacyFabrick extends Component {
    constructor(props) {
        super(props)
    }
    onChange() {
        const { component, dispatch } = this.props
    
        if (!this.input.disabled) {
          if (component.status.indexOf('checkonly') > -1) {
            if (component.value !== 'selected') {
              dispatch(
                updateComponent(component.id, {
                  value: 'selected'
                })
              )
              if (!!component.action)
              {
              dispatch(updateComponent(component.id, component.action))
              }
            }
          } else {
            dispatch(
              updateComponent(component.id, {
                value: this.input.checked ? 'selected' : ''
              })
            )
          }
        }
    }
    render() {
        const { widget, component } = this.props
        return (
            <div>
                {/* <div className='labellink'>Letta e compresa <a id="lnkprivacyfabrick" className='link' href="https://www.fabrick.com/transparency/FBK_PP_IT_IT_INFORMATIVAPRIVACY_CLIENTI_H20.pdf" target='_blank'>l'informativa sul trattamento dei dati personali di</a> Fabrick S.p.A.</div> */}
                {!!component && <div
                    {...css(
                        this.props.styles.component,
                        this.props.styles.checkbox,
                        this.props.styles['component--block'],
                        this.props.styles[`component--pull-${component.pullTo}`],
                        this.props.styles.checkboxContainer
                    )}
                >
                    <div>     <input
                        ref={input => {
                            this.input = input
                        }}
                        type="checkbox"
                        id={component.id}
                        {...css(this.props.styles.input)}
                        checked={component.value === 'selected'}
                        onChange={() => this.onChange()}
                        name={component.id}
                    />
                        <label
                            htmlFor={component.id}
                            {...css(
                                this.props.styles.label,
                                component.status.indexOf('error') > -1 &&
                                this.props.styles['label--invalid']
                            )}
                        >
                            Presto il consenso al trattamento dei miei dati personali da parte di Fabrick S.p.A. per svolgere le seguenti attività di marketing: rilevazione del grado di soddisfazione della clientela sulla qualità dei servizi resi; compimento di studi e ricerche di mercato; sviluppo e vendita di servizi propri e/o di società del Gruppo Sella e/o di terzi, con modalità, tra le quali, l’invio di comunicazioni a carattere informativo, promozionale e commerciale (le attività potranno essere svolte attraverso e-mail, SMS, notifiche push, posta cartacea, telefono con operatore e social network). (cfr. par. 4, lett. c)
                        </label>
                    </div>
                </div>}
            </div>
        )
    }
}
PrivacyFabrick.propTypes = {
    widget: PropTypes.object.isRequired,
    component: PropTypes.object.isRequired,
    //styles: PropTypes.object.isRequired
  }
const mapStateToProps = (state, ownProps) => {
    const { components } = state
    return { component: components[ownProps.component.id] }
}
export default connect(mapStateToProps)(withStyles(Styles)(PrivacyFabrick))


// WEBPACK FOOTER //
// ./components/privacyfabrick/index.js